import { createFileRoute } from "@tanstack/react-router";
import { TEMPLATE_CHANNEL } from "@offsilo/contracts/automation";
import { z } from "zod";
import { MessageEditor } from "@/features/workflows/MessageEditor";

const search = z.object({ channel: TEMPLATE_CHANNEL.optional() });

export const Route = createFileRoute("/_app/automations/messages/$template")({
  validateSearch: search,
  component: () => {
    const { template } = Route.useParams();
    return <MessageEditor id={template} />;
  },
});
